<mat-tab-group>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">gavel</mat-icon>
      Inicio
    </ng-template>
    <br>
    <ng-template matTabContent>
      <div class="tab-content">
          <app-dashboard-inicio></app-dashboard-inicio>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">gavel</mat-icon>
      Expedientes
    </ng-template>
    <br>

      <ng-template matTabContent>
        <div class="tab-content">
          <app-dashboard-expedientes></app-dashboard-expedientes>
        </div>
      </ng-template>
  </mat-tab>


  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">task</mat-icon>
      Tareas
    </ng-template>
    <br>

      <ng-template matTabContent>
        <div class="tab-content">
        <app-dashboard-tareas></app-dashboard-tareas>
        </div>
      </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">account_balance</mat-icon>
      Movimientos
    </ng-template>
    <br>

      <ng-template matTabContent>
        <div class="tab-content">
          <app-dashboard-movimientos></app-dashboard-movimientos>
        </div>
      </ng-template>
  </mat-tab>


</mat-tab-group>
